import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type LinkExternal02IconProps = IconProps

const LinkExternal02Icon = forwardRef<SVGSVGElement, LinkExternal02IconProps>(
  (props: LinkExternal02IconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 9V3m0 0h-6m6 0-9 9m-2-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V14"
        fill="none"
      ></path>
    </Icon>
  ),
)

LinkExternal02Icon.displayName = 'LinkExternal02Icon'
LinkExternal02Icon.defaultProps = iconDefaultProps

export type { LinkExternal02IconProps }
export { LinkExternal02Icon }
